var _circle, _circle2, _circle3, _circle4, _circle5, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAi360(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "eks-icon-ai360"
  }, "AI360") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "eks-icon-ai360"
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 5,
    r: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 5,
    r: 1.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 19,
    r: 1.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19,
    r: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.2l4 4.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 6.2l-4 4.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 17.8l4-4.4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 17.8l-4-4.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi360);
export default __webpack_public_path__ + "static/media/ai360.d7a3a7f3909072376a0f6da2b449e706.svg";
export { ForwardRef as ReactComponent };